<template>

  <div class="user">
    <!--筛选条件-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="协议名称">
          <el-input placeholder="请输入协议名称" v-model="formInline.name" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="协议分类">
          <el-select v-model="formInline.category" placeholder="请选择协议分类" clearable style="width: 150px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="安全承诺书" value="1"></el-option>
            <el-option label="安全责任书" value="2"></el-option>
            <el-option label="安全告知书" value="3"></el-option>
            <el-option label="其他文件签订" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建组织">
          <el-select v-model="formInline.organization" placeholder="请选择创建组织" clearable filterable style="width: 150px;">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in organizationList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="formInline.create_time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加协议</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="category_name" label="协议分类" width="100"></el-table-column>
            <el-table-column prop="name" label="协议名称" min-width="150"></el-table-column>
            <el-table-column prop="total_people" label="总人数" width="80" align="center"></el-table-column>
            <el-table-column prop="organization_name" label="创建组织" width="150"></el-table-column>
            <!-- <el-table-column prop="status" label="状态" width="80" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                  {{ scope.row.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column> -->
            <el-table-column prop="signing_entity" label="签订主体" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.signing_entity === '1' ? '部门' : scope.row.signing_entity === '2' ? '公司' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="effective_start_date" label="有效开始日期" width="120"></el-table-column>
            <el-table-column prop="effective_end_date" label="有效截止日期" width="120"></el-table-column>
            <el-table-column label="到期时间" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.is_long_term">长期有效</span>
                <span v-else>{{ scope.row.expire_time }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <!-- <el-table-column prop="enable_time" label="启用时间" width="150"></el-table-column> -->
            <el-table-column prop="creator" label="创建人" width="100"></el-table-column>
            <el-table-column prop="description" label="说明" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :xieyi_id="xieyi_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          name: "",
          category: "",
          organization: "",
          create_time: []
        },
        /*组织列表*/
        organizationList: [],
        open_add:false,
        open_edit:false,
        xieyi_id:""
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
      /*获取组织列表*/
      this.getOrganizationList();
    },
    methods: {
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    /*重置搜索*/
    resetSearch(){
      this.formInline = {
        name: "",
        category: "",
        organization: "",
        create_time: []
      };
      this.curPage = 1;
      this.getTableList();
    },
    getData(){
      this.curPage = 1;
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        if(this.formInline.name){
          Params.name = this.formInline.name;
        }
        if(this.formInline.category){
          Params.category = this.formInline.category;
        }
        if(this.formInline.organization){
          Params.organization = this.formInline.organization;
        }
        if(this.formInline.create_time && this.formInline.create_time.length === 2){
          Params.create_time_start = this.formInline.create_time[0];
          Params.create_time_end = this.formInline.create_time[1];
        }
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        AfuncApi.call({
          model: 'xieyi',
          action: 'getList',
          ...Params
        })
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*获取组织列表*/
      getOrganizationList() {
        let self = this;
        let Params = {
          page: 1,
          list_rows: 1000
        };
        AfuncApi.call({
        model: 'ma_company',
        action: 'getList',
        ...Params
      })
          .then(data => {
            self.organizationList = data.data.list.data || [];
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.xieyi_id = row.xieyi_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            AfuncApi.call({
              model: 'xieyi',
              action: 'del',
              xieyi_id: row.xieyi_id
            })
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/xieyi/index.vue